import ApiClient from "./ApiClient"

import DataSourceSync from "../types/DataSourceSync"

export const DataSourceSyncApi = {

    apiPath: 'data-source-syncs',

    getAll: async (search?: string): Promise<DataSourceSync[]> => {
        const items: DataSourceSync[] = []
        const params = new URLSearchParams([
            ['lockingSystemId', localStorage.getItem('selectedLockingSystemId') as string]
        ])

        if (search) params.append('search', search)

        const response = await ApiClient.get(DataSourceSyncApi.apiPath, { params });

        for (let item of response.data.data) {
            items.push(item)
        }

        return items
    },

    add: async (newItem: DataSourceSync, handleAddItem: (id: number) => void): Promise<DataSourceSync> => {
        const result = await ApiClient.post(DataSourceSyncApi.apiPath, newItem);
        const itemRef = result.data.data;

        handleAddItem(itemRef.id);

        return result?.data.data
    },

    delete: async(id: number): Promise<any> => {
        return await ApiClient.delete(DataSourceSyncApi.apiPath + '/' + id);
    },

    edit: async (item: DataSourceSync): Promise<DataSourceSync> => {
        const result = await ApiClient.put(
            DataSourceSyncApi.apiPath + '/' + item.id, item
        );

        return result?.data.data
    },

    run: async (item: DataSourceSync): Promise<any> => {
        const result = await ApiClient.get(
            DataSourceSyncApi.apiPath + '/' + item.id + '/run'
        )

        return result?.data
    },

    toggle: async (item: DataSourceSync, values: object): Promise<any> => {
        const result = await ApiClient.put(
            DataSourceSyncApi.apiPath + '/' + item.id + '/toggle', values
        );

        return result?.data.data
    }
}